import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import CatalogObjectReference from '@square/dashboard-items-data/models/invoices/cart/catalog-object-reference';
import Money from '@square/dashboard-money/models/money';
import LegacyMoney from '@square/dashboard-data/utils/legacy-money';
export function getPrice(itemModifier, unitToken) {
  if (!itemModifier) {
    return undefined;
  }
  const defaultPrice = itemModifier.price || Money.zero();
  if (!unitToken) {
    return defaultPrice;
  }
  const unitOverridePrice = itemModifier.getUnitOverride?.(unitToken, 'price');
  const unitOverridePriceMoney = unitOverridePrice ? Money.fromCents(unitOverridePrice.cents) : undefined;
  return unitOverridePriceMoney || defaultPrice;
}
export default ProtoBaseModel.extend({
  id: attr(String),
  name: attr(String),
  ordinal: attr(Number),
  price: attr(LegacyMoney),
  onByDefault: attr(Boolean),
  modifierList: attr(Object),
  catalogObjectReference: attr(CatalogObjectReference)
}).reopenClass({
  createFor(itemModifier, unitToken) {
    if (!itemModifier) {
      return undefined;
    }
    const price = getPrice(itemModifier, unitToken);
    return this.create({
      id: itemModifier.get('id'),
      name: itemModifier.get('name'),
      ordinal: itemModifier.get('ordinal'),
      price,
      onByDefault: itemModifier.get('onByDefault'),
      modifierList: {
        id: itemModifier.get('modifierList.id'),
        type: {}
      },
      catalogObjectReference: CatalogObjectReference.fromCatalogModel(itemModifier)
    });
  }
});